import { render, staticRenderFns } from "./MytestpaperManage.vue?vue&type=template&id=147737af"
import script from "./MytestpaperManage.vue?vue&type=script&lang=js"
export * from "./MytestpaperManage.vue?vue&type=script&lang=js"
import style0 from "./MytestpaperManage.vue?vue&type=style&index=0&id=147737af&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports